import Vue from 'vue';
import Vuex from 'vuex';
import UtilsService from './services/UtilsService';
import VuexPersistence from 'vuex-persist';
import Notification from 'elementui-lts/lib/notification';
import i18n from './main';

import createFiltroInteligenciaTerritorial from './models/FiltroInteligenciaTerritorial';
import traceabilityContractModule from '@/modules/traceability-contract/stores';
import relatorioRastreabilidadeModule from '@/modules/traceability-report/stores';
import certificationStoreModule from '@/modules/certification/stores';
import warehouseModule from '@/modules/warehouse/stores';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

Vue.use(Vuex);

const isEmptyOrNull = value => {
    return value == null || value.length === 0;
};

const isProductionEnv = process.env.NODE_ENV === 'production';
const vm = Vue.prototype;

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'exportaPDF',
    restoreState: (key, storage) =>
        JSON.parse(window.localStorage.getItem(key)),
    reducer: state => ({ marcarExportarPDF: state.marcarExportarPDF }),
    filter: mutation =>
        mutation.type === 'SET_MARCAR_EXPORTAR_PDF' ||
        mutation.type === 'CLEAR_MARCAR_EXPORTAR_PDF' ||
        mutation.type === 'REMOVE_ITEM_MARCAR_EXPORTAR_PDF'
});

const INITIAL_STATE = {
    usuarioLogado: null,
    usuarioIsLaudo: null,
    filtro: {
        cliente: null,
        matricula: null,
        estados: [],
        municipios: [],
        cultura: null
    },
    abaSelecionadaAreaMonitorada: null,
    safra: null,
    dadosNovaArea: {
        contato: null,
        propriedade: null,
        dadosMonitoramento: null
    },
    abaSelecionadaRepresentante: null,
    abaSelecionadaTerritorio: null,
    territorio: {},
    edicaoSimplesTerritorio: false,
    recriarMonitoramentos: [],
    territoryTableData: [],
    monitoramentoModal: false,
    geometriaDesenhadaAcao: {},
    marcarExportarPDF: [],
    emProcessamentoPDF: false,
    acaoEscolhida: null,
    representante: {
        id: null,
        usuario: null,
        idUsuario: null,
        nomeRazaoSocial: null,
        cpfCnpj: null,
        idCliente: null,
        email: null,
        ativo: null,
        dataCadastro: null,
        dataAtualizacao: null,
        empresas: null,
        cpfCnpjCrypt: null
    },
    ativarCamadaCar: false,
    carSelecionadoNaPopup: null,
    showCamadaToEdit: false,
    geometriaToShow: null,
    identificadorGeometria: null,
    limparUltimaGeometria: null,
    limparCamadas: false,
    operacao: {
        filtro: '',
        filtrosStatus: [],
        filtrarOperacoesComAlertas: false
    },
    responsePreAnalisePF: null,
    marcarExportarNeowayPDF: [],
    emProcessamentoNeowayPDF: false,
    emProcessamentoUploadLoteRenovabio: false,
    uploadLoteRenovabioConcluido: false,
    emProcessamentoDownloadLoteRenovabio: false,
    limparSelecaoLoteRenovabio: false,
    laudosSelecionadosDownloadLoteRenovabio: [],
    hashPlanilhaRenovabio: null,
    carsVinculadosSocioambiental: false,
    carsVinculadosAgricola: false,
    tipoAgrupamentoMapaInteligenciaTerritorial: {
        visaoGeral: '',
        nomeMunicipio: '',
        municipio: null
    },
    glebaVisualizada: {},
    modeloPlanilhaSIG: '',
    filtroInteligenciaTerritorial: {
        cicloSafra: 1,
        tipoAgrupamento: 'PAIS',
        codigosCulturas: null,
        idsMunicipios: [],
        siglaEstado: null,
        codigosCars: [],
        nome: null,
        possuiRestricao: null,
        areaImovelInicial: null,
        areaPlantadaInicial: null,
        areaPastagemInicial: null,
        estadoId: null,
        objEstado: null,
        municipioSelecionado: null
    },
    camadasPermitidasPorUsuarioState: [],
    arrayTodosMunicipiosEstadoInteligenciaTerritorial: [],
    idsMunicipiosInteligenciaTerritorialRanking: [],
    filtroMonitoramento: {},
    culturaFiltrada: null,
    empresasSubEmpresasPorPais: []
};

export default new Vuex.Store({
    modules: {
        traceabilityContractModule,
        relatorioRastreabilidadeModule,
        certification: certificationStoreModule,
        warehouseModule
    },
    state: Object.assign({}, INITIAL_STATE),

    getters: {
        filtro: state => state.filtro,

        isFiltering: state =>
            !isEmptyOrNull(state.filtro.cliente) ||
            !isEmptyOrNull(state.filtro.matricula) ||
            !isEmptyOrNull(state.filtro.estados) ||
            !isEmptyOrNull(state.filtro.municipios) ||
            !isEmptyOrNull(state.filtro.diretoriasNegocios),

        culturaSelecionada: state => state.filtro.cultura,

        abaSelecionadaAreaMonitorada: state =>
            state.abaSelecionadaAreaMonitorada,

        abaSelecionadaRepresentante: state =>
            state.abaSelecionadaAreaMonitorada,

        abaSelecionadaTerritorio: state => state.abaSelecionadaAreaMonitorada,

        isViewingAreaMonitorada: state =>
            state.abaSelecionadaAreaMonitorada != null,

        safras: state => state.safra.filter(s => !s.safrinha),

        safrinhas: state => state.safra.filter(s => s.safrinha),

        hasSafras: state => state.safra !== null,

        territorioData: state => state.territorio,

        isEdicaoSimplesTerritorio: state => state.edicaoSimplesTerritorio,

        getRecriarMonitoramentos: state => state.recriarMonitoramentos,

        territoryTableData: state => state.territoryTableData,

        showMonitoramentoModal: state => state.monitoramentoModal,

        geometriaDesenhadaAcao: state => state.geometriaDesenhadaAcao,

        marcarExportarPDF: state => state.marcarExportarPDF,

        emProcessamentoPDF: state => state.emProcessamentoPDF,

        acaoEscolhida: state => state.acaoEscolhida,

        representante: state => state.representante,

        usuarioLogado: state => state.usuarioLogado,

        marcarExportarNeowayPDF: state => state.marcarExportarNeowayPDF,

        emProcessamentoUploadLoteRenovabio: state =>
            state.emProcessamentoUploadLoteRenovabio,

        uploadLoteRenovabioConcluido: state =>
            state.uploadLoteRenovabioConcluido,

        hashPlanilhaRenovabio: state => state.hashPlanilhaRenovabio,

        emProcessamentoDownloadLoteRenovabio: state =>
            state.emProcessamentoDownloadLoteRenovabio,

        laudosSelecionadosDownloadLoteRenovabio: state => state.laudosSelecionadosDownloadLoteRenovabio,

        limparSelecaoLoteRenovabio: state => state.limparSelecaoLoteRenovabio,

        emProcessamentoNeowayPDF: state => state.emProcessamentoNeowayPDF,

        showCarsVinculadosSocioambiental: state =>
            state.carsVinculadosSocioambiental,

        showCarsVinculadosAgricola: state => state.carsVinculadosAgricola,

        filtroInteligenciaTerritorial: state =>
            state.filtroInteligenciaTerritorial,

        filtroMonitoramento: state => state.filtroMonitoramento,

        culturaFiltrada: state => state.culturaFiltrada,

        ambienteBr: state =>
            state.usuarioLogado &&
            state.usuarioLogado.paisGrupo === AmbientesEmpresas.BRASIL,

        ambientePy: state =>
            state.usuarioLogado &&
            state.usuarioLogado.paisGrupo === AmbientesEmpresas.PARAGUAY,

        ambienteAr: state =>
            state.usuarioLogado &&
            state.usuarioLogado.paisGrupo === AmbientesEmpresas.ARGENTINA,

        empresasSubEmpresasPorPais: state => state.empresasSubEmpresasPorPais
    },

    mutations: {
        SET_USUARIO_IS_LAUDO(state, usuarioIsLaudo) {
            state.usuarioIsLaudo = usuarioIsLaudo;
        },
        SET_FILTROS_OPERACAO: (
            state,
            { filtro, filtrosStatus, filtrarOperacoesComAlertas }
        ) => {
            state.operacao.filtro = filtro;
            state.operacao.filtrosStatus = filtrosStatus;
            state.operacao.filtrarOperacoesComAlertas =
                filtrarOperacoesComAlertas;
        },

        SET_FILTRO: (state, filtro) => {
            state.filtro = filtro;
        },

        RESET_FILTRO: state => {
            state.filtro = INITIAL_STATE.filtro;
        },

        SET_CULTURA_SELECIONADA(state, culturaSelecionada) {
            state.filtro.cultura = culturaSelecionada;
        },

        SET_ABA_AREA_MONITORADA(state, aba) {
            state.abaSelecionadaAreaMonitorada = aba;
        },

        SET_SAFRA(state, safra) {
            state.safra = safra;
        },

        SET_DADOS_NOVA_AREA(state, dados) {
            state.dadosNovaArea = Object.assign(state.dadosNovaArea, dados);
        },

        SET_USUARIO_LOGADO(state, usuario) {
            state.usuarioLogado = usuario;
            sessionStorage.setItem(
                'dadosUsuario',
                usuario ? JSON.stringify(usuario) : null
            );
        },

        UPDATE_USUARIO_LOGADO_AMBIENTE(state, novoAmbiente) {
            state.usuarioLogado.paisGrupo = novoAmbiente;
        },

        UPDATE_USUARIO_LOGADO_LOCALE(state, locale) {
            state.usuarioLogado.locale = locale;
        },

        SET_ABA_REPRESENTANTE(state, aba) {
            state.abaSelecionadaRepresentante = aba;
        },

        SET_ABA_TERRITORIO(state, aba) {
            state.abaSelecionadaTerritorio = aba;
        },

        SET_TERRITORIO(state, territorio) {
            state.territorio = territorio;
        },

        SET_EDICAO_SIMPLES_TERRITORIO(state, edicaoSimplesTerritorio) {
            state.edicaoSimplesTerritorio = edicaoSimplesTerritorio;
        },

        SET_RECRIAR_MONITORAMENTOS(state, recriarMonitoramentos) {
            state.recriarMonitoramentos = recriarMonitoramentos;
        },

        RESET_TERRITORIO: state => {
            state.territorio = INITIAL_STATE.territorio;
        },

        SET_TERRITORY_TABLE_DATA: (state, territoryTableData) => {
            state.territoryTableData.push(territoryTableData);
        },

        SET_ATIVAR_CAMADA_CAR: (state, ativarCamadaCar) => {
            state.ativarCamadaCar = ativarCamadaCar;
        },

        SET_CAR_SELECIONADO_NA_POPUP: (state, carSelecionadoNaPopup) => {
            state.carSelecionadoNaPopup = carSelecionadoNaPopup;
        },

        SET_LIMPAR_ULTIMA_GEOMETRIA: (state, limparUltimaGeometria) => {
            state.limparUltimaGeometria = limparUltimaGeometria;
        },

        SET_LIMPAR_CAMADAS: (state, limparCamadas) => {
            state.limparCamadas = limparCamadas;
        },

        SET_SHOW_CAMADA_TO_EDIT: (
            state,
            { showCamadaToEdit, geometriaToShow, identificadorGeometria }
        ) => {
            state.showCamadaToEdit = showCamadaToEdit;
            state.geometriaToShow = geometriaToShow;
            state.identificadorGeometria = identificadorGeometria;
        },

        CLEAR_TERRITORY_TABLE_DATA: state => {
            state.territoryTableData = [];
        },

        REMOVE_ITEM_TERRITORY_TABLE_DATA: (state, payload) => {
            state.territoryTableData = state.territoryTableData.filter(
                (value, index) => {
                    if (index !== payload) {
                        return value;
                    }
                }
            );
        },

        CHANGE_MONITORAMENTO_MODAL: state => {
            state.monitoramentoModal = !state.monitoramentoModal;
        },

        REPLACE_TERRITORY_TABLE_DATA: (state, editedTerritoryTableData) => {
            state.territoryTableData = state.territoryTableData.map(
                territorio => {
                    if (
                        territorio.identificadorGeometria ===
                        editedTerritoryTableData.identificadorGeometria
                    ) {
                        return {
                            ...territorio,
                            ...editedTerritoryTableData
                        };
                    }
                    return territorio;
                }
            );
        },

        SET_GEOMETRIA_DESENHADA_ACAO: (state, geometria) => {
            state.geometriaDesenhadaAcao = { ...geometria };
        },

        RESET_GEOMETRIA_DESENHADA_ACAO: (state, geometria) => {
            state.geometriaDesenhadaAcao = {
                ...INITIAL_STATE.geometriaDesenhadaAcao
            };
        },

        SET_MARCAR_EXPORTAR_PDF: (state, marcarExportarPDF) => {
            if (state.emProcessamentoPDF) {
                Notification.warning({
                    message: i18n.t(
                        'mensagens.sistema.exportacaoEmProcessamentoAguarde'
                    )
                });
                return;
            }

            if (state.marcarExportarPDF === null) state.marcarExportarPDF = [];

            if (
                !state.marcarExportarPDF.some(
                    item =>
                        item.nome === marcarExportarPDF.nome &&
                        item.protocolo === marcarExportarPDF.protocolo
                )
            ) {
                if (state.marcarExportarPDF.length < 5) {
                    state.marcarExportarPDF.push(marcarExportarPDF);
                } else {
                    Notification.warning({
                        message: i18n.t(
                            'mensagens.sistema.permitidoAteCincoDocumentosParaExportacao'
                        )
                    });
                }
            } else {
                Notification.warning({
                    message: i18n.t(
                        'mensagens.sistema.documentoJaConstaNaListagemParaExportacao'
                    )
                });
            }
        },

        SET_EM_PROCESSAMENTO_PDF: state => {
            state.emProcessamentoPDF = true;
        },

        CLEAR_MARCAR_EXPORTAR_PDF: state => {
            state.marcarExportarPDF = [];
            state.emProcessamentoPDF = false;
        },

        REMOVE_ITEM_MARCAR_EXPORTAR_PDF: (state, payload) => {
            state.marcarExportarPDF = state.marcarExportarPDF.filter(value => {
                if (value.idLista !== payload) {
                    return value;
                }
            });
            state.geometriaDesenhadaAcao = { ...INITIAL_STATE.acaoEscolhida };
        },

        SET_ACAO_ESCOLHIDA: (state, acao) => {
            state.acaoEscolhida = { ...acao };
        },

        RESET_ACAO_ESCOLHIDA: (state, acao) => {
            state.acaoEscolhida = { ...INITIAL_STATE.acaoEscolhida };
        },

        SET_REPRESENTANTE: (state, representante) => {
            state.representante = { ...representante };
        },

        SET_RESPONSE_PRE_ANALISE_PF: (state, responsePreAnalisePF) => {
            state.responsePreAnalisePF = responsePreAnalisePF;
        },

        SET_MARCAR_EXPORTAR_NEOWAY_PDF: (state, marcarExportarNeowayPDF) => {
            if (state.emProcessamentoNeowayPDF) {
                Notification.warning({
                    message: i18n.t(
                        'mensagens.sistema.exportacaoEmProcessamentoAguarde'
                    )
                });
                return;
            }

            if (state.marcarExportarNeowayPDF === null) {
                state.marcarExportarNeowayPDF = [];
            }

            if (
                !state.marcarExportarNeowayPDF
                    .map(pdf => pdf.documento)
                    .includes(marcarExportarNeowayPDF.documento)
            ) {
                if (state.marcarExportarNeowayPDF.length < 5) {
                    state.marcarExportarNeowayPDF.push(marcarExportarNeowayPDF);
                } else {
                    Notification.warning({
                        message: i18n.t(
                            'mensagens.sistema.permitidoAteCincoDocumentosParaExportacao'
                        )
                    });
                }
            } else {
                Notification.warning({
                    message: i18n.t(
                        'mensagens.sistema.documentoJaConstaNaListagemParaExportacao'
                    )
                });
            }
        },

        SET_EM_PROCESSAMENTO_NEOWAY_PDF: state => {
            state.emProcessamentoNeowayPDF = true;
        },

        SET_EM_PROCESSAMENTO_UPLOAD_LOTE_RENOVABIO: state => {
            state.emProcessamentoUploadLoteRenovabio = true;
        },

        SET_UPLOAD_LOTE_RENOVABIO_CONCLUIDO: state => {
            state.uploadLoteRenovabioConcluido = true;
        },

        CLEAR_EM_PROCESSAMENTO_UPLOAD_LOTE_RENOVABIO: state => {
            state.emProcessamentoUploadLoteRenovabio = false;
        },

        CLEAR_UPLOAD_LOTE_RENOVABIO_CONCLUIDO: state => {
            state.uploadLoteRenovabioConcluido = false;
        },

        SET_HASH_PLANILHA_RENOVABIO: (state, hashPlanilhaRenovabio) => {
            state.hashPlanilhaRenovabio = hashPlanilhaRenovabio;
        },

        SET_EM_PROCESSAMENTO_DOWNLOAD_LOTE_RENOVABIO: state => {
            state.emProcessamentoDownloadLoteRenovabio = true;
        },

        CLEAR_EM_PROCESSAMENTO_DOWNLOAD_LOTE_RENOVABIO: state => {
            state.emProcessamentoDownloadLoteRenovabio = false;
        },

        SET_LIMPAR_SELECAO_LOTE_RENOVABIO: (state, payload) => {
            state.limparSelecaoLoteRenovabio = payload;
        },

        SET_LAUDOS_SELECIONADOS_DOWNLOAD_LOTE_RENOVABIO: (
            state,
            laudosSelecionadosDownloadLoteRenovabio
        ) => {
            state.laudosSelecionadosDownloadLoteRenovabio =
                laudosSelecionadosDownloadLoteRenovabio;
        },

        CLEAR_MARCAR_EXPORTAR_NEOWAY_PDF: state => {
            state.marcarExportarNeowayPDF = [];
            state.emProcessamentoNeowayPDF = false;
        },

        REMOVE_ITEM_MARCAR_EXPORTAR_NEOWAY_PDF: (state, payload) => {
            state.marcarExportarNeowayPDF =
                state.marcarExportarNeowayPDF.filter(value => {
                    if (value.idLista !== payload) {
                        return value;
                    }
                });
            state.geometriaDesenhadaAcao = { ...INITIAL_STATE.acaoEscolhida };
        },

        CHANGE_CARS_VINCULADOS_SOCIOAMBIENTAL_MODAL: state => {
            state.carsVinculadosSocioambiental =
                !state.carsVinculadosSocioambiental;
        },

        CHANGE_CARS_VINCULADOS_AGRICOLA_MODAL: state => {
            state.carsVinculadosAgricola = !state.carsVinculadosAgricola;
        },
        SET_FILTRO_INTELIGENCIA_TERRITORIAL: (
            state,
            filtroInteligenciaTerritorial
        ) => {
            state.filtroInteligenciaTerritorial = {
                ...filtroInteligenciaTerritorial
            };
        },
        SET_TIPO_AGRUPAMENTO_MAPA_INTELIGENCIA_TERRITORIAL: (
            state,
            { visaoGeral, nomeMunicipio, municipio }
        ) => {
            state.tipoAgrupamentoMapaInteligenciaTerritorial.visaoGeral =
                visaoGeral;
            state.tipoAgrupamentoMapaInteligenciaTerritorial.nomeMunicipio =
                nomeMunicipio;
            state.tipoAgrupamentoMapaInteligenciaTerritorial.municipio =
                municipio;
        },
        SET_GLEBA_VISUALIZADA: (state, gleba) => {
            state.glebaVisualizada = gleba;
        },
        SET_CAMADAS_POR_USUARIO: (state, camadasPermitidasPorUsuarioState) => {
            state.camadasPermitidasPorUsuarioState =
                camadasPermitidasPorUsuarioState;
        },
        SET_MODELO_PLANILHA_SIG: (
            state,
            idsMunicipiosInteligenciaTerritorialRanking
        ) => {
            state.idsMunicipiosInteligenciaTerritorialRanking =
                idsMunicipiosInteligenciaTerritorialRanking;
        },
        SET_IDS_MUNICIPIOS_INTELIGENCIA_TERRITORIAL_RANKING: (state, idsMunicipiosInteligenciaTerritorialRanking) => {
            state.idsMunicipiosInteligenciaTerritorialRanking = idsMunicipiosInteligenciaTerritorialRanking;
        },
        SET_ARRAY_TODOS_MUNICIPIOS_ESTADO_INTELIGENCIA_TERRITORIAL: (state, arrayTodosMunicipiosEstadoInteligenciaTerritorial) => {
            state.arrayTodosMunicipiosEstadoInteligenciaTerritorial = arrayTodosMunicipiosEstadoInteligenciaTerritorial;
        },
         SET_CULTURA_FILTRADA: (state, culturaFiltrada) => {
             state.culturaFiltrada = culturaFiltrada;
         },

        RESET_CULTURA_FILTRADA: state => {
            state.culturaFiltrada = INITIAL_STATE.culturaFiltrada;
        },
        RESET_CAMADAS_PERMITIDAS_POR_USUARIO: state => {
            state.camadasPermitidasPorUsuarioState = INITIAL_STATE.camadasPermitidasPorUsuarioState;
        },
        SET_FILTRO_MONITORAMENTO: (state, filtro) => {
            state.filtroMonitoramento = filtro;
        },
        RESET_FILTRO_MONITORAMENTO: state => {
            state.filtroMonitoramento = INITIAL_STATE.filtroMonitoramento;
        },
        SET_EMPRESAS_PAIS(state, empresasSubEmpresasPorPais) {
            state.empresasSubEmpresasPorPais = empresasSubEmpresasPorPais;
        }
    },

    actions: {
        setUsuarioIsLaudo({ commit }, usuarioIsLaudo) {
            commit('SET_USUARIO_IS_LAUDO', usuarioIsLaudo);
        },
        filtrar: ({ commit }, filtro) => {
            commit('SET_FILTRO', filtro);
        },

        limparFiltro: ({ commit }) => {
            commit('RESET_FILTRO');
        },

        fetchSafra: async ({ commit }) => {
            const safra = await UtilsService.getSafras();
            commit('SET_SAFRA', safra.data);
        },

        setDadosNovaArea({ commit }, dados) {
            commit('SET_DADOS_NOVA_AREA', dados);
        },

        setUsuarioLogado({ commit }, dadosUsuario) {
            commit('SET_USUARIO_LOGADO', dadosUsuario);
        },

        updateUsuarioLogadoAmbiente({ commit }, novoAmbiente) {
            commit('UPDATE_USUARIO_LOGADO_AMBIENTE', novoAmbiente);
        },

        updateUsuarioLogadoLocale({ commit }, locale) {
            commit('UPDATE_USUARIO_LOGADO_LOCALE', locale);
        },

        setAbaRepresentante({ commit }, aba) {
            commit('SET_ABA_REPRESENTANTE', aba);
        },

        setAbaTerritorio({ commit }, aba) {
            commit('SET_ABA_TERRITORIO', aba);
        },

        setTerritorio({ commit }, territorio) {
            commit('SET_TERRITORIO', territorio);
        },

        setEdicaoSimplesTerritorio({ commit }, edicaoSimplesTerritorio) {
            commit('SET_EDICAO_SIMPLES_TERRITORIO', edicaoSimplesTerritorio);
        },

        setRecriarMonitoramentos({ commit }, recriarMonitoramentos) {
            commit('SET_RECRIAR_MONITORAMENTOS', recriarMonitoramentos);
        },

        clearTerritorio({ commit }) {
            commit('RESET_TERRITORIO');
        },

        setAtivarCamadaCar({ commit }, ativarCamadaCar) {
            commit('SET_ATIVAR_CAMADA_CAR', ativarCamadaCar);
        },

        setCarSelecionadoNaPopup({ commit }, carSelecionadoNaPopup) {
            commit('SET_CAR_SELECIONADO_NA_POPUP', carSelecionadoNaPopup);
        },

        setLimparUltimaGeometria({ commit }, limparUltimaGeometria) {
            commit('SET_LIMPAR_ULTIMA_GEOMETRIA', limparUltimaGeometria);
        },

        setLimparCamadas({ commit }, limparCamadas) {
            commit('SET_LIMPAR_CAMADAS', limparCamadas);
        },

        setShowCamadaToEdit(
            { commit },
            { showCamadaToEdit, geometriaToShow, identificadorGeometria }
        ) {
            commit('SET_SHOW_CAMADA_TO_EDIT', {
                showCamadaToEdit,
                geometriaToShow,
                identificadorGeometria
            });
        },

        setTerritoryTableData({ commit }, territoryTableData) {
            commit('SET_TERRITORY_TABLE_DATA', territoryTableData);
        },

        removeTerritoryTableData({ commit }, territoryTableData) {
            commit('REMOVE_ITEM_TERRITORY_TABLE_DATA', territoryTableData);
        },

        clearTerritoryTableData({ commit }, territoryTableData) {
            commit('CLEAR_TERRITORY_TABLE_DATA', territoryTableData);
        },

        changeShowMonitoramentoModal({ commit }) {
            commit('CHANGE_MONITORAMENTO_MODAL');
        },

        replaceTerritoryTableData({ commit }, territoryTableData) {
            commit('REPLACE_TERRITORY_TABLE_DATA', territoryTableData);
        },

        setGeometriaDesenhadaAcao({ commit }, geometria) {
            commit('SET_GEOMETRIA_DESENHADA_ACAO', geometria);
        },

        removerGeometriaDesenhadaAcao({ commit }) {
            commit('RESET_GEOMETRIA_DESENHADA_ACAO');
        },

        setMarcarExportar_PDF({ commit }, marcarExportarPDF) {
            commit('SET_MARCAR_EXPORTAR_PDF', marcarExportarPDF);
        },

        removeMarcarExportar_PDF({ commit }, marcarExportarPDF) {
            commit('REMOVE_ITEM_MARCAR_EXPORTAR_PDF', marcarExportarPDF);
        },

        clearMarcarExportar_PDF({ commit }, marcarExportarPDF) {
            commit('CLEAR_MARCAR_EXPORTAR_PDF', marcarExportarPDF);
        },

        setEmProcessamento_PDF({ commit }) {
            commit('SET_EM_PROCESSAMENTO_PDF');
        },

        setEmProcessamentoEmLoteRenovabio({ commit }) {
            commit('SET_EM_PROCESSAMENTO_EM_LOTE_RENOVABIO');
        },

        setAcaoEscolhida({ commit }, acao) {
            commit('SET_ACAO_ESCOLHIDA', acao);
        },

        removerAcaoEscolhida({ commit }) {
            commit('RESET_ACAO_ESCOLHIDA');
        },

        setRepresentante({ commit }, representante) {
            commit('SET_REPRESENTANTE', representante);
        },

        setResponsePreAnalisePF({ commit }, responsePreAnalisePF) {
            commit('SET_RESPONSE_PRE_ANALISE_PF', responsePreAnalisePF);
        },

        setMarcarExportarNeoway_PDF({ commit }, marcarExportarNeowayPDF) {
            commit('SET_MARCAR_EXPORTAR_NEOWAY_PDF', marcarExportarNeowayPDF);
        },

        removeMarcarExportarNeoway_PDF({ commit }, marcarExportarNeowayPDF) {
            commit(
                'REMOVE_ITEM_MARCAR_EXPORTAR_NEOWAY_PDF',
                marcarExportarNeowayPDF
            );
        },

        clearMarcarExportarNeoway_PDF({ commit }, marcarExportarNeowayPDF) {
            commit('CLEAR_MARCAR_EXPORTAR_NEOWAY_PDF', marcarExportarNeowayPDF);
        },

        setEmProcessamentoNeoway_PDF({ commit }) {
            commit('SET_EM_PROCESSAMENTO_NEOWAY_PDF');
        },

        setEmProcessamentoUploadLoteRenovabio({ commit }) {
            commit('SET_EM_PROCESSAMENTO_UPLOAD_LOTE_RENOVABIO');
        },

        setUploadLoteRenovabioConcluido({ commit }) {
            commit('SET_UPLOAD_LOTE_RENOVABIO_CONCLUIDO');
        },

        clearEmProcessamentoUploadLoteRenovabio({ commit }) {
            commit('CLEAR_EM_PROCESSAMENTO_UPLOAD_LOTE_RENOVABIO');
        },

        clearUploadLoteRenovabioConcluido({ commit }) {
            commit('CLEAR_UPLOAD_LOTE_RENOVABIO_CONCLUIDO');
        },

        setHashPlanilhaRenovabio({ commit }, hashPlanilhaRenovabio) {
            commit('SET_HASH_PLANILHA_RENOVABIO', hashPlanilhaRenovabio);
        },

        setEmProcessamentoDownloadLoteRenovabio({ commit }) {
            commit('SET_EM_PROCESSAMENTO_DOWNLOAD_LOTE_RENOVABIO');
        },

        clearEmProcessamentoDownloadLoteRenovabio({ commit }) {
            commit('CLEAR_EM_PROCESSAMENTO_DOWNLOAD_LOTE_RENOVABIO');
        },

        setLaudosSelecionadosDownloadLoteRenovabio({ commit }, laudosSelecionadosDownloadLoteRenovabio) {
            commit('SET_LAUDOS_SELECIONADOS_DOWNLOAD_LOTE_RENOVABIO', laudosSelecionadosDownloadLoteRenovabio);
        },

        setLimparSelecaoLoteRenovabio({ commit }, payload) {
            commit('SET_LIMPAR_SELECAO_LOTE_RENOVABIO', payload);
        },

        changeShowCarsVinculadosSocioambientalModal({ commit }) {
            commit('CHANGE_CARS_VINCULADOS_SOCIOAMBIENTAL_MODAL');
        },

        changeShowCarsVinculadosAgricolaModal({ commit }) {
            commit('CHANGE_CARS_VINCULADOS_AGRICOLA_MODAL');
        },
        setFiltroInteligenciaTerritorial(
            { commit },
            filtroInteligenciaTerritorial
        ) {
            commit(
                'SET_FILTRO_INTELIGENCIA_TERRITORIAL',
                filtroInteligenciaTerritorial
            );
        },
        limparFiltroInteligenciaTerritorial({ commit }) {
            const filtro = createFiltroInteligenciaTerritorial();
            commit('SET_FILTRO_INTELIGENCIA_TERRITORIAL', filtro);
        },
        setTipoAgrupamentoMapaInteligenciaTerritorial(
            { commit },
            { visaoGeral, nomeMunicipio, municipio }
        ) {
            commit('SET_TIPO_AGRUPAMENTO_MAPA_INTELIGENCIA_TERRITORIAL', {
                visaoGeral,
                nomeMunicipio,
                municipio
            });
        },
        setModeloPlanilhaSig({ commit }, modeloPlanilhaSig) {
            commit('SET_MODELO_PLANILHA_SIG', modeloPlanilhaSig);
        },
        setGlebaVisualizada({ commit }, gleba) {
            commit('SET_GLEBA_VISUALIZADA', gleba);
        },
        setCamadasPermitidasPorUsuario(
            { commit },
            camadasPermitidasPorUsuarioState
        ) {
            commit('SET_CAMADAS_POR_USUARIO', camadasPermitidasPorUsuarioState);
        },
        setIdsMunicipiosInteligenciaTerritorialRanking(
            { commit },
            idsMunicipiosInteligenciaTerritorialRanking
        ) {
            commit(
                'SET_IDS_MUNICIPIOS_INTELIGENCIA_TERRITORIAL_RANKING',
                idsMunicipiosInteligenciaTerritorialRanking
            );
        },
        setArrayTodosMunicipiosEstadoInteligenciaTerritorial(
            { commit },
            arrayTodosMunicipiosEstadoInteligenciaTerritorial
        ) {
            commit(
                'SET_ARRAY_TODOS_MUNICIPIOS_ESTADO_INTELIGENCIA_TERRITORIAL',
                arrayTodosMunicipiosEstadoInteligenciaTerritorial
            );
        },
        processarEventoGoogleAnalytics(
            { state },
            { eventLabel, pageTitle, routeName, routePath, keyValue = null }
        ) {
            if (isProductionEnv) {
                vm.$gtag.event(eventLabel, {
                    event_category: 'view_item',
                    event_label: eventLabel,
                    value: keyValue
                        ? `${state?.usuarioLogado?.nome} - ${keyValue}`
                        : state?.usuarioLogado?.nome
                });
            }
        },

        setfiltroMonitoramento: ({ commit }, filtro) => {
            commit('SET_FILTRO_MONITORAMENTO', filtro);
        },

        limparFiltroMonitoramento: ({ commit }) => {
            commit('RESET_FILTRO_MONITORAMENTO');
        },

        setCulturaFiltrada: ({ commit }, culturaFiltrada) => {
            commit('SET_CULTURA_FILTRADA', culturaFiltrada);
        },

        limparCulturaFiltrada: ({ commit }) => {
            commit('RESET_CULTURA_FILTRADA');
        },

        limparCamadasPermitidasPorUsuario: ({ commit }) => {
            commit('RESET_CAMADAS_PERMITIDAS_POR_USUARIO');
        },

        fetchEmpresasSubEmpresasPorPais: async ({ commit }, pais) => {
            const empresasSubEmpresasPorPais = await UtilsService.buscarTodasEmpresasSubEmpresas(pais);
            commit('SET_EMPRESAS_PAIS', empresasSubEmpresasPorPais.data);
        }
    },

    plugins: [vuexLocal.plugin]
});
